/**
 * The Bullseye's colours, as whole Tailwind class names so the JIT scanner
 * finds them (a class built from a template string is never emitted).
 *
 * Lists take the categorical `--chart-*` family minus teal, green and cyan
 * (`chart-1`, `chart-4`, `chart-5`), which vanish on the teal rings: pink,
 * blue, amber, violet, then indigo, in that order. Rings take the tenure ramp
 * (`--tenure-5` strongest in the centre, `--tenure-1` lightest outside), which
 * already has a value per theme.
 */
import type { ringTone } from "./bullseyeGeometry";

export interface ListTone {
  fill: string;
  stroke: string;
  bg: string;
}

const LIST_TONES: readonly ListTone[] = [
  { fill: "fill-chart-7", stroke: "stroke-chart-7", bg: "bg-chart-7" },
  { fill: "fill-chart-8", stroke: "stroke-chart-8", bg: "bg-chart-8" },
  { fill: "fill-chart-2", stroke: "stroke-chart-2", bg: "bg-chart-2" },
  { fill: "fill-chart-3", stroke: "stroke-chart-3", bg: "bg-chart-3" },
  { fill: "fill-chart-6", stroke: "stroke-chart-6", bg: "bg-chart-6" },
];

/** The tone of the list at `index` in the search's list order (stable when lists are switched off). */
export function listTone(index: number): ListTone {
  return LIST_TONES[index % LIST_TONES.length] as ListTone;
}

type Tone = ReturnType<typeof ringTone>;

export const RING_FILL: Record<Tone, string> = {
  1: "fill-tenure-1",
  2: "fill-tenure-2",
  3: "fill-tenure-3",
  4: "fill-tenure-4",
  5: "fill-tenure-5",
};

export const RING_BG: Record<Tone, string> = {
  1: "bg-tenure-1",
  2: "bg-tenure-2",
  3: "bg-tenure-3",
  4: "bg-tenure-4",
  5: "bg-tenure-5",
};
